'use client';
import cn from 'classnames';
import { useSearch } from '@/components/hook/search';
import LoadingSpinner from '@/components/common/LoadingSpinner/LoadingSpinner';
import ProductCard from '@/components/common/ProductCard/ProductCard';
import Text from '@/components/common/Text/Text';

import { algoliaResultToProductCard } from '@/util/search';

import './NewArrivalsCarousel.style.scss';
import ProductCardCarousel from '@/components/common/ProductCardCarousel/ProductCardCarousel';

type NewArrivalsCarouselProps = {
  className?: string;
  headline?: string;
  mobileDisplayMode?: 'carousel' | 'two-per-row-grid';
};

const NEW_ARRIVALS_QUERY = { newArrivals: true, hitsCount: 10 } as const;

function NewArrivalsCarousel(props: NewArrivalsCarouselProps) {
  const { className = '', headline, mobileDisplayMode = 'carousel' } = props;

  const { loading, results } = useSearch(NEW_ARRIVALS_QUERY);

  const productCardData = results?.data?.hits.map(algoliaResultToProductCard);

  return (
    <div className={cn('NewArrivalsCarousel', className)}>
      {headline && (
        <Text
          className='NewArrivalsCarousel-headline'
          italic
          variant='title-l'
        >
          {headline}
        </Text>
      )}

      {loading && (
        <LoadingSpinner
          className='NewArrivalsCarousel-LoadingSpinner'
          size={50}
        />
      )}

      {productCardData && (
        <ProductCardCarousel
          className={cn(
            'NewArrivalsCarousel-carousel',
            mobileDisplayMode,
            className
          )}
          data={productCardData}
        />
      )}
      {productCardData && mobileDisplayMode === 'two-per-row-grid' && (
        <div className={'NewArrivalsCarousel-two-per-row-grid'}>
          {productCardData.map((cardData) => {
            return (
              <ProductCard
                className='NewArrivalsCarousel-grid-item'
                data={cardData}
                key={cardData.sku}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

export default NewArrivalsCarousel;
